import { HStack, Pressable } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';
import { isWeb } from 'utils/environment';

import { BORDER_BOTTOM_VALUE } from './constants';
const listItemStyles = {
  flexGrow: 1,
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.token('background-pattern'),
  color: theme.token('text-default'),
  paddingY: 4,
  paddingX: 4,
};

export const ListItemContent = HStack.withConfig<{ isHeader?: boolean }>(p => ({
  ...listItemStyles,
  ...(p.isHeader && { backgroundColor: primitive.bk.$mayoEggWhite }),
  ...(isWeb && { flex: 1 }),
  borderBottomColor: theme.token('border-color-default'),
  borderBottomWidth: BORDER_BOTTOM_VALUE,
}));

export const ListItemButton = Pressable.withConfig<{ isHeader?: boolean }>(p => ({
  ...listItemStyles,
  ...(p.isHeader && { backgroundColor: primitive.bk.$mayoEggWhite }),
  flexDirection: 'row',
  borderBottomColor: theme.token('border-color-default'),
  borderBottomWidth: BORDER_BOTTOM_VALUE,
  flexShrink: 1,
}));

export const ProductControl = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: '$2',
});
